import AbstractNode from './AbstractNode';
import {messageColors} from '../helper/messageColors';
import {TextSelection} from 'prosemirror-state';

const supportedVariation = [...messageColors.map(color => color.value), 'information'];

export default class ContainerMessage extends AbstractNode {
    get name() {
        return "container_message";
    }

    get schema() {
        return {
            attrs: {
                variation: {default: null}
            },
            content: "(paragraph | blockquote | horizontal_rule | heading | code_block | ordered_list | bullet_list | checkbox_list | code_container_mermaid | code_container_plantuml | math_block | table | table_of_contents)+",
            group: "block",
            parseDOM: [{
                tag: '.message, .note, .caution, .callout'
            }],
            toDOM: node => ["div", {
                class: 'ui visible message' + (node.attrs.variation ? ` ${node.attrs.variation}` : '')
            }, 0]
        }
    }

    toMarkdown(state, node) {
        const variation = node.attrs.variation ? ` ${node.attrs.variation}` : '';
        state.write(`:::message${variation}\n`);
        state.renderContent(node);
        state.ensureNewLine();
        state.write(":::");
        state.closeBlock(node);
    }

    get parseMarkdown() {
        return {
            block: "container_message", getAttrs: token => {
                const variation = token.info.trim().substring('message '.length);
                return {
                    variation: supportedVariation.includes(variation) ? variation : undefined
                }
            }
        }
    }

    commands({schema}) {
        return {
          createMessage: () => view => {
            const offset = view.state.tr.selection.anchor + 1;
            const tr = view.state.tr.replaceSelectionWith(schema.nodes.container_message.createAndFill()).scrollIntoView();
            const resolvedPos = tr.doc.resolve(offset);
            view.dispatch(tr.setSelection(TextSelection.near(resolvedPos)));
          }
        }
    }
}